module.exports = __webpack_public_path__ + "img/cheatsheet_icon_projects_2x.72819a1a.png";